import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';

import { MatterService } from '../../../services/matters/matter.service';

@Component({
  selector: 'app-matter-exhibits',
  templateUrl: './matter-exhibits.component.html',
  styleUrls: ['./matter-exhibits.component.css'],
})
export class MatterExhibitsComponent implements OnInit, OnChanges {
  @Input() matter_id: number;

  exhibits: any = [];
  exhibits_loading: boolean = true;

  constructor(private matterService: MatterService) {}

  // Component lifecycle events
  ngOnInit() {
    this.loadExhibits();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.matter_id && changes.matter_id.currentValue) this.loadExhibits();
  }

  // Component methods
  loadExhibits() {
    this.matterService.getExhibits(this.matter_id).then((response_json) => {
      this.exhibits = response_json;
      this.exhibits_loading = false;
    });
  }

  downloadExhibitsUrl(): string {
    return `/matters/${this.matter_id}/download_exhibits`;
  }
}
